import styled from 'styled-components';

export const DoohInventoryFiltersLoadingStyled = styled.div`
  padding: 0 20px;
  background: ${props => props.theme.uiColors.background01};
`;

export const DoohInventoryFiltersStyled = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;
  background: ${props => props.theme.uiColors.background01};
  display: flex;
  flex-direction: column;
  row-gap: 8px;

  .doohInventoryFilters {
    &__search {
      display: flex;
      align-items: center;
      width: 100%;
      column-gap: 8px;

      &ByName {
        width: 100%;
      }
    }

    &__selectors {
      display: flex;
      align-items: center;
      width: 100%;
      row-gap: 8px;
      column-gap: 8px;

      > div {
        flex: 1;
        max-width: 20%;
      }
    }
  } 
`;
